import { Page } from '@dixa/lib-shared-habla';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { config } from 'lib-shared-backend-config';
import { useMemo } from 'react';

import { BillingPaymentMethodsSection } from './components/billingPaymentMethodsSection/billingPaymentMethodsSection';
import { BillingInformationSection } from './components/billlingInformationSection/billingInformationSection';

export const SettingsBillingView = (): JSX.Element => {
  const stripePromise = useMemo(() => loadStripe(config.sdk.stripe), []);

  return (
    <Elements stripe={stripePromise}>
      <Page>
        <Page.Head title="Billing" />

        <Page.Body>
          <BillingInformationSection />
          <BillingPaymentMethodsSection />
        </Page.Body>
      </Page>
    </Elements>
  );
};
